import { useContext } from "react";
import { Menu } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { DataTableContext } from "../../context/DataTableContext";

export interface Props {
  record: any;
  hasEdit?: boolean;
  hasDelete?: boolean;
}

const ActionMenu = ({ record, hasEdit, hasDelete }: Props) => {
  const {
    setVisible,
    setDeleteModalVisible,
    setUpdate,
    setDefaultFields,
    setId,
  } = useContext(DataTableContext);

  const handleEdit = (record: any) => {
    setUpdate(true);
    setId(record.id);
    setDefaultFields(record);
    setVisible(true);
  };
  const handleDelete = (record: any) => {
    setId(record.id);
    setDeleteModalVisible(true);
  };

  return (
    <Menu
      mode="horizontal"
      style={{ borderBottom: 0, background: "transparent" }}
    >
      {hasEdit && (
        <Menu.Item
          onClick={() => handleEdit(record)}
          key="edit"
          style={{ borderBottom: 0, marginLeft: 0, color: "#57AEA1" }}
        >
          <EditOutlined />
        </Menu.Item>
      )}
      {hasDelete && (
        <Menu.Item
          onClick={(e) => handleDelete(record)}
          key="delete"
          style={{ borderBottom: 0, marginLeft: 0, color: "#DF3636" }}
        >
          <DeleteOutlined type="delete" />
        </Menu.Item>
      )}
    </Menu>
  );
};

export default ActionMenu;
